import { render, staticRenderFns } from "./UgiInputWithUnit.vue?vue&type=template&id=552f90a4&scoped=true&"
import script from "./UgiInputWithUnit.vue?vue&type=script&lang=js&"
export * from "./UgiInputWithUnit.vue?vue&type=script&lang=js&"
import style0 from "./UgiInputWithUnit.vue?vue&type=style&index=0&id=552f90a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f90a4",
  null
  
)

export default component.exports